// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"f0e5bb68","196":"f0e5bb68"}[chunkId] + ".chunk.css";
};